import styled from 'styled-components';

export const Loader = styled('div')`
  & {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    position: relative;
    animation: rotate 1s linear infinite;
    transition: opacity 1s ease-out 100ms;
    box-shadow: 0px 5px #88888855;
  }

  &::before , &::after {
    content: "";
    box-sizing: border-box;
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    border: 10px solid ${props => props.theme.colors.primary};
    animation: prixClipFix 2s linear infinite ;
  }

  &::after{
    transform: rotate3d(90, 90, 0, 180deg );
    border-color: ${props => props.theme.colors.brand};
  }

  @keyframes rotate {
    0%   {transform: rotate(0deg)}
    100%   {transform: rotate(360deg)}
  }

  @keyframes prixClipFix {
      0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}
      50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}
      75%, 100%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}
  }
`
